module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Clark_CR-e611b7c8374328b64ba55a7186cb6cf2.jpg";